import { frontendURL } from 'dashboard/helper/URLHelper';

// custom (2026-08-09): NOTAS — o bloco de notas pessoal, item top-level da sidebar.
//
// NÃO é sub-item do CRM, e a distinção importa: o CRM é o processo de venda da empresa;
// isto é o caderno da pessoa. Pendurá-lo debaixo de "CRM" diria que o que ela escreve ali
// pertence ao processo — e é justamente o contrário, a aba existe para o que não cabe nele.
//
// `permissions` inclui administrador e operador porque os dois têm um caderno. O que NÃO
// existe é um caminho para o administrador ler o caderno do operador (ver
// CrmNotesController) — mesma aba, caixas separadas.
//
// A visibilidade real é a flag por conta `crm_notas` (off por padrão), lida pela sidebar.
// A rota continua alcançável por link direto com a flag desligada, e nesse caso a tela
// recebe 404 da API e mostra o estado de indisponível — mesmo comportamento do resto do CRM.
export const notasRoutes = [
  {
    path: frontendURL('accounts/:accountId/notas'),
    name: 'crm_notas',
    component: () => import('./CrmNotas.vue'),
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
